export default __webpack_public_path__ + "e0c8e311f3b85eea1706aa9d02ed6c78.svg";